import { createFileRoute } from '@tanstack/react-router';

import { MigrationAssessmentPage } from '@/components/features/migration-assessment/MigrationAssessmentPage';

export const Route = createFileRoute('/_protected/t/$tenantId/migration-assessment/')({
  component: MigrationAssessmentPage,
});
